var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"request-button-bar"},[_c('div',{staticClass:"vacancy-row"},[_c('div',{class:[
        'vacancy-text',
        {
          orangeColor: _vm.showOrangeFont,
          greenColor: _vm.showGreenFont,
          grayColor: _vm.showGrayFont,
          pinkColor: _vm.showPinkFont,
          isEntryRestricted: _vm.isEntryRestricted,
        },
      ],domProps:{"innerHTML":_vm._s(_vm.showVacancyText)}})]),(!_vm.isHideVacancyCountText)?_c('div',{class:[
      'total-count',
      {
        orangeColor: _vm.showOrangeFont,
        greenColor: _vm.showGreenFont,
        grayColor: _vm.showGrayFont,
        pinkColor: _vm.showPinkFont,
        isEntryRestricted: _vm.isEntryRestricted,
      },
    ]},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.showCongestionText))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }